import React from 'react';
import {observer} from "mobx-react";
import {APP} from "../../../core/app/consts";
import {DescriptionHeader} from "../../../core/components/description-header/description-header.async";
import {ACTION_TYPES} from "../../../core/consts";

export const CompetitorContainerDescriptionHeader = observer(({controller}) => {
  const {device, state} = controller;
  const {isSmallView} = device
  const {currentLinkModel, descriptionHeader, competitorViewModel, competitorId} = state


  const onEntityClick = () => {
    controller.action(ACTION_TYPES.entityClick, {
      entityId: competitorId,
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[competitorViewModel.domainModel?.objectType],
      source: APP.ANALYTICS.SOURCES[currentLinkModel?.name],
      currentLinkModel: currentLinkModel,
      sportTypeId: competitorViewModel?.sport?.id
    });

    return true;
  };

  const descriptionHeaderProps = {
    controller,
    currentLinkModel,
    entity: descriptionHeader,
    shouldRenderDescriptionHeader: true,
    useEntityColor: isSmallView,
    onTitleClick: descriptionHeader?.entity?.linkModel ? () => onEntityClick() : null,
  }

  return isSmallView ? <DescriptionHeader {...descriptionHeaderProps}/> : null
})
